export const endPoints = {
  ONE_COMPAGING_CALL: "v1/robot-call/calls/all",
  CALLS_STATUS: "v1/robot-call/calls/stat-status",
  CALLS_DURATION: "v1/robot-call/calls/stat-duration"
}